import { LuCheck } from "react-icons/lu";
import QuoteStepHeading from "../../../../shared/components/QuoteStepHeading";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import SupportStep from "../../enums/SupportStep";

const StepNavDisplay = () => {
  const selectedOptions =
    useAppStateStore((state) => state.selectedOptions) || [];
  const spCurrentStep = useAppStateStore((state) => state.spCurrentStep);
  const safeOptions = Array.isArray(selectedOptions) ? selectedOptions : [];
  const currentIndex = safeOptions.findIndex(
    (option) => option.id === spCurrentStep,
  );

  return (
    <QuoteFormWrapper>
      <QuoteStepHeading
        title="Your selected changes"
        className="tw-mb-4"
        titleClassName="tw-m-0 tw-text-xl"
        mobileTitleClassName="max-sm:tw-text-lg"
      />
      {safeOptions.length > 0 ? (
        <div className="tw-flex tw-flex-wrap tw-gap-2">
          {safeOptions.map((option, index) => {
            const isComplete =
              spCurrentStep === SupportStep.SP_COMPLETE ||
              (currentIndex >= 0 && index < currentIndex);

            return (
              <div
                className="tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-dis-navy tw-bg-dis-navy tw-pl-2 tw-pr-3 tw-py-2 tw-text-base tw-font-semibold tw-text-white"
                key={option.id}
              >
                <span className="tw-flex tw-h-5 tw-w-5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-dis-sky tw-text-xs tw-text-dis-navy">
                  {isComplete ? (
                    <LuCheck className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                  ) : (
                    index + 1
                  )}
                </span>
                <span>{option.title}</span>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="tw-m-0 tw-text-base tw-text-dis-text-muted">
          No options selected
        </p>
      )}
    </QuoteFormWrapper>
  );
};

export default StepNavDisplay;
